import axios from "axios";

const API_PATH = '/LuxgenVIG/VIGP1/driverManagement/driverForgetPassword';
const API_PATH1 = `${process.env.REACT_APP_ENV === 'local' ? '' : '/tsp'}/manage/dashboard/forget`;

const DriverForgetPassword = async searches => (
	await axios.post(API_PATH, searches)
);

const ManageForgetPassword = async searches => (
	await axios.post(API_PATH1, searches)
);

export { DriverForgetPassword, ManageForgetPassword };
